var macro = require("assets/config/entities/predefined-content.json").macro;

// constants
var REG_EXP_PATTERN = new RegExp(macro.regex.pattern);
var REG_EXP_PREFIX = macro.regex.prefix.replace(/\$/g, '\\$');
var REG_EXP_SUFFIX = macro.regex.suffix;

// map created by the predefined-content.json macro entry
var macroMap = {};

// initializes the macroMap
// each entry will contain an object with:
// - regexp: regex representing the macro field, for example: $!{operator.displayname}
// - replacer: a function that receives data objects and extracts from them the required field.
//             the 'replacer' result is the value that will replace the 'regexp' macro placeholder
function init() {
    Object.keys(macro.patterns).forEach(function (key) {
        macroMap[key] = {
            regexp: new RegExp(REG_EXP_PREFIX + key + REG_EXP_SUFFIX, 'g'),
            replacer: function (context) {
                var value = context;
                var pattern = macro.patterns[key];
                var paths = pattern.split('.');
                paths.forEach(function (path) {
                    value = value && value[path];
                });
                return value || '';
            }
        };
    });
}

function test(line) {
    return REG_EXP_PATTERN.test(line);
}

function replace(line, context) {
    if (line) {
        Object.keys(macroMap).forEach(function (key) {
            line = line.replace(macroMap[key].regexp, macroMap[key].replacer(context));
        });
    }
    return line;
}

init();

module.exports = {
    test: test,
    replace: replace
};
